import { connect, Dispatch } from 'react-redux'

import { openModal } from '../../../common/actions/layout'
import { IBannerApiData } from '../../../common/actions/marketing/banner'
import { getUserProfile } from '../../../common/actions/user/'
import { getSessionSuccessAction } from '../../../common/actions/user/session'
import { Site } from '../../../common/constants/siteList'
import { IRootState } from '../../../common/reducers'
import {
  IEnhancedLocation,
  ILocationParams
} from '../../../common/reducers/reactRouterLocation'
import { hasFeature } from '../../../common/utils/features'
import makeSearchLink from '../../../common/utils/location/makeSearchLink'
import { makeLink } from '../../../common/utils/urlHelper'
import SiteHeader from '../components/header/siteHeader'

interface IStateProps {
  banners: IBannerApiData[]
  currentSite: Site
  menuConfig: any[]
  location: IEnhancedLocation
  experiments: any
  makeSearchLink: (params: ILocationParams, currentSite?: Site) => string
}

interface IDispatchProps {
  handleSignInSuccess: (token: string) => any
  openModal: (data: any) => any
}

const mapStateToProps = (state: IRootState): IStateProps => {
  const { common, marketing, router, experiments } = state
  const { currentSite, menuConfig } = common
  const { banners } = marketing
  const { location } = router

  const newRoutesEnabled = hasFeature(
    'routes:new',
    currentSite,
    location,
    experiments
  )

  return {
    banners,
    currentSite,
    menuConfig,
    location,
    experiments,
    makeSearchLink: newRoutesEnabled ? makeSearchLink : makeLink
  }
}

const mapDispatchToProps = (dispatch: Dispatch<IRootState>): IDispatchProps => {
  return {
    handleSignInSuccess: (token: string) => {
      dispatch(getSessionSuccessAction(token))
      return dispatch(getUserProfile(token) as any)
    },
    openModal: (data: any) => dispatch(openModal(data))
  }
}

export type Props = IStateProps & IDispatchProps

const SiteHeaderContainer = connect<
  IStateProps,
  IDispatchProps,
  any,
  IRootState
>(mapStateToProps, mapDispatchToProps)(SiteHeader)

export default SiteHeaderContainer
